import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import {
  DvSplitterEventsService,
  DvSplitterResizableSide,
} from '@devinco/ui/dds/splitter';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-reports-page',
  templateUrl: './reports-page.component.html',
  styleUrls: ['../../styles/page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReportsPage implements OnInit {
  private splitterEvents = inject(DvSplitterEventsService);
  private permissionsService = inject(UserRolesAndPermissionsService);

  resizableSide: typeof DvSplitterResizableSide = DvSplitterResizableSide;
  canAddReport$: Observable<boolean>;

  ngOnInit(): void {
    this.canAddReport$ = this.permissionsService.hasPermissions([
      RolesAndPermissions.ReportEdit,
    ]);
  }

  onCreateClick(): void {
    this.splitterEvents.isSplitterOpened$.next(true);
  }
}
